// Filtering the projects

const projects = [...document.querySelectorAll('.c-tease--hover')];
const links = [...document.querySelectorAll('.c-page__body a[href^="#"]')];
let currentFilter = '';
let current = 'all';

function filterHandler(e) {
  e.preventDefault();

  // Check if currentFilter has ever been set
  if (currentFilter) {
    currentFilter.classList.remove('js-active');
  }

  // Update currentFilter
  currentFilter = e.target;

  // Get the current target class to filter by
  const [currTarget] = e.target.parentNode.getAttribute('class').split(' ');

  // Set current click into a var so we can toggle
  if (currTarget === current) {
    current = 'all';
  } else {
    current = currTarget;
    e.target.classList.add('js-active');
  }

  projects.forEach((project) => {
    // Reset all on each click
    project.classList.remove('inactive', 'active');

    if (current !== 'all' && !project.classList.contains(current)) {
      project.classList.add('inactive');
    } else {
      project.classList.add('active');
    }
  });

  window.dispatchEvent(new CustomEvent('work:filter-changed'));
}

links.forEach((link) => {
  link.addEventListener('click', filterHandler);
});
